'use client';

import * as React from 'react';
import dynamic from 'next/dynamic';
import {
  extractCoverImageAtom,
  showCodeLineNumberAtom,
} from 'app/blog/[domain]/_components/design-state';
import { useAtomValue } from 'jotai';

export type DynamicStyleProps = {
  katex?: boolean;
};

export const CODE_LINE_NUMBER_STYLE = `
code {
  counter-reset: line;
}

code > [data-line]::before {
  counter-increment: line;
  content: counter(line);

  display: inline-block;
  width: 1rem;
  margin-right: 2rem;
  text-align: right;
  color: gray;
}

code[data-line-numbers-max-digits='2'] > [data-line]::before {
  width: 2rem;
}

code[data-line-numbers-max-digits='3'] > [data-line]::before {
  width: 3rem;
}
`;

export const HIDE_COVER_STYLE = `
.prose [data-cover=true]{
  display: none;
}
`;

const DynamicKatex = dynamic(() => import('./katex'));

export function DynamicStyles({ katex }: DynamicStyleProps): JSX.Element {
  const showCodeLineNumber = useAtomValue(showCodeLineNumberAtom);
  const extractCoverImage = useAtomValue(extractCoverImageAtom);
  return (
    <>
      {/* Procedence and href make sure the style is rendered in html head */}
      <style precedence="dynamic" href="post-dynamic">{`
        ${showCodeLineNumber ? CODE_LINE_NUMBER_STYLE : ''}

        ${extractCoverImage ? HIDE_COVER_STYLE : ''}
      `}</style>
      {katex && <DynamicKatex />}
    </>
  );
}
